import React, { FC, useEffect } from 'react'
import styled from 'styled-components'
import { useReviewStep } from '@ally/create-flow'
import {
  FromAccount,
  ToAccount,
  Amount,
  DeliveryDate,
  Fee,
  Transfer,
  TransferSpeed,
  DisclosureMessages,
} from '@ally/transfers-toolkit'
import { ButtonGroup, Button, Box, Space, Stack } from '@ally/metronome-ui'

const StyledStack = styled(Stack)`
  align-items: stretch;
`

const LoadingWrapper = styled(Box)<{ isLoading: boolean }>(
  ({ isLoading }): string => {
    if (!isLoading) return ''
    return `
      opacity: 0.7;
      pointer-events: none;
    `
  },
)

export const Review: FC<{ setFocusOnTitle: () => void }> = ({
  setFocusOnTitle,
}) => {
  const { item: transfer, save, cancel, edit, isSaving } = useReviewStep<
    Transfer
  >()

  const { fromAccount, toAccount, amount, transferSpeed } = transfer

  /**
   * We manually setting focus instead of letting create-flow handle it since
   * the focus ref is in a parent element
   */
  useEffect(setFocusOnTitle, [])

  return (
    <LoadingWrapper isLoading={isSaving}>
      <dl style={{ margin: 0 }}>
        <StyledStack space="xs">
          <Box>
            <FromAccount.Display asTile account={fromAccount} />
          </Box>

          <Box>
            <ToAccount.Display asTile account={toAccount} />
          </Box>

          <Box>
            <Amount.Display amount={amount} />
          </Box>

          <Box>
            <DeliveryDate.Display transfer={transfer} />
          </Box>

          <Box>
            <TransferSpeed.Display
              transferSpeed={transferSpeed}
              fromAccount={fromAccount}
              toAccount={toAccount}
            />
          </Box>

          <Box>
            <Fee.Display fee={0} />
          </Box>

          <DisclosureMessages transfer={transfer} isWidget />
        </StyledStack>

        <Space mt="sm">
          <ButtonGroup>
            <Button
              text="Submit"
              onClick={save}
              allytmln="TW Submit Transfer"
            />
            <Button
              variant="link"
              text="Edit"
              onClick={edit}
              allytmln="TW Edit Transfer"
            />
            <Button
              variant="link"
              text="Cancel"
              onClick={cancel}
              allytmln="TW Cancel Transfer"
            />
          </ButtonGroup>
        </Space>
      </dl>
    </LoadingWrapper>
  )
}
